import {defaultErrorMessage} from '@cohort/shared/models';
import {useTurnstile} from '@cohort/shared-frontend/hooks/useTurnstile';
import EmailVerificationModal from '@cohort/wallet/components/modals/auth/EmailVerificationModal';
import useNotify from '@cohort/wallet/hooks/notify';
import {useApi} from '@cohort/wallet/hooks/useApi';
import {useMerchantContext} from '@cohort/wallet/hooks/useMerchantContext';
import {UserApi} from '@cohort/wallet/lib/Endpoints';
import {trackError} from '@cohort/wallet/lib/Tracking';
import React, {useCallback, useEffect, useRef} from 'react';

type NftTransfertLoginProps = {
  recipientEmail: string;
  onSuccessLogin: () => void;
};

export const NftTransferLogin: React.FC<NftTransfertLoginProps> = ({
  recipientEmail,
  onSuccessLogin,
}) => {
  const merchant = useMerchantContext();
  const sendSigninCode = useApi(UserApi.sendSigninCode);
  const {token, resetToken} = useTurnstile();
  const initialized = useRef(false);
  const notify = useNotify();

  const handleEmailSignIn = useCallback(
    async (email: string, turnstileToken: string) => {
      try {
        await sendSigninCode(email, merchant.slug, turnstileToken);
      } catch (err: unknown) {
        trackError(err);
      } finally {
        resetToken?.();
      }
    },
    [sendSigninCode, merchant.slug, resetToken]
  );

  useEffect(() => {
    if (!token || initialized.current) {
      return;
    }
    handleEmailSignIn(recipientEmail, token).catch((err: unknown) => {
      trackError(err);
      notify('error', defaultErrorMessage);
    });
    return () => {
      initialized.current = true;
    };
  }, [handleEmailSignIn, recipientEmail, notify, token]);

  return (
    <div className="flex h-full w-full items-start md:items-center">
      <EmailVerificationModal
        email={recipientEmail}
        merchantSlug={merchant.slug}
        handleGoBack={() => {}}
        successCallback={onSuccessLogin}
        hideEmailChange
      />
    </div>
  );
};
